import { render } from "./ShippingItemsIconField.vue?vue&type=template&id=3f2adc88&scoped=true"
import script from "./ShippingItemsIconField.vue?vue&type=script&lang=js"
export * from "./ShippingItemsIconField.vue?vue&type=script&lang=js"

import "./ShippingItemsIconField.vue?vue&type=style&index=0&id=3f2adc88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2adc88"]])

export default __exports__